import React, { useState, useContext, useEffect } from "react";
import { format } from "date-fns";
import { useLocation } from "react-router-dom";

//package import

import {
  Box,
  Typography,
  Grid,
  Avatar,
  Paper,
  useTheme,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
} from "@mui/material";

import UploadFileIcon from "@mui/icons-material/UploadFile";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";

//user imports

import { RoutesUrls, ministryRoutes } from "../Services/Routes/APP";

import { ministry_Context } from "../context";
import { headersPost } from "../Services/API";
import { MINISTRY_API_ULRS } from "../Services/Routes/API";
import {
  getNthIndexOfSubstringInString,
  getAllIndexes,
} from "../common/functions";
import { useDecodedToken } from "../Services/Routes/APP/PrivateRoute";

const useStyles = makeStyles({
  hiddenScrollBar: {
    padding: "1rem",
    overflowY: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});

const UploadCSV = ({showCsvModal, handleCsvModalToggle}) => {
  // states
  const [csvFile, setCsvFile] = useState(false);
  const [csvDataRows, setCsvDataRows] = useState([]);
  const [csvDataHeaders, setCsvDataHeaders] = useState([]);
  const [csvMappedData, setCsvMappedData] = useState([]);
  const [csvSortedMappedData, setCsvSortedMappedData] = useState([]);
  const [csvFileDataPreview, setCsvFileDataPreview] = useState(false);
  const [nodesTree, setNodesTree] = useState({});
  const [alertOpen, setAlertOpen] = useState(false);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");

  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();

  const user = useDecodedToken();

  //handle alert close

  const handleAlertClose = () => {
    setAlertOpen(false);
    setAlertMsg("");
    setAlertIcon("error");
  };

  //CSV upload functions

  const fileUpload = () => {
    const data = {
      nodes_tree: nodesTree,
    };
    setLoaderOpen(true);
    headersPost(MINISTRY_API_ULRS.UPLOAD_NODES_FILE, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setLoaderOpen(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          handleFileUploadModalClose();
        } else {
          setLoaderOpen(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          setLoaderOpen(false);
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setLoaderOpen(false);
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const handleFileUploadModalClose = () => {
    setCsvFileDataPreview(false);
    setCsvDataHeaders([]);
    setCsvDataRows([]);
    setCsvFile(false);
    if (handleCsvModalToggle) {
      handleCsvModalToggle(false);
    }
    setNodesTree({});
    setCsvMappedData([]);
    setCsvSortedMappedData([]);
  };

  //handle CSV File

  const handleCsvFile = () => {
    const file = csvFile;
    const reader = new FileReader();

    reader.onload = function (e) {
      const text = e.target.result;

      processCSV(text);
    };

    reader.readAsText(file);
  };

  const createNodesTree = () => {
    const roles = ["ministry", "state", "district", "hospital"];
    let tree = {};

    roles.forEach((role) => {
      let node = {};
      csvSortedMappedData.forEach((row) => {
        let alteredRow = {
          user: {},
          data: {},
        };

        for (const [key, value] of Object.entries(row)) {
          if (key.includes("user")) {
            const replacedKey = key.replace("user_", "");
            alteredRow["user"][replacedKey] = value;
          } else {
            alteredRow["data"][key] = value;
          }
        }

        if (alteredRow?.data?.category === role) {
          switch (role) {
            case roles[0]:
              node = {
                data: alteredRow?.data,
                users: [],
                children: [],
              };
              if (Object.keys(tree).length === 0) {
                node.users.push(alteredRow?.user);
                tree = node;
              } else {
                if (tree?.data?.unique_id === node?.data?.unique_id) {
                  tree?.users?.push(alteredRow?.user);
                }
              }
              break;

            case roles[1]:
              node = {
                data: alteredRow?.data,
                users: [],
                children: [],
              };
              if (
                alteredRow?.data?.parent_unique_id === tree?.data?.unique_id
              ) {
                let dataExistsAlready = false;
                tree?.children?.length > 0 &&
                  tree?.children?.forEach((child, i) => {
                    if (child?.data?.unique_id === node?.data?.unique_id) {
                      dataExistsAlready = true;
                      tree?.children[i]?.users?.push(alteredRow?.user);
                    }
                  });
                if (!dataExistsAlready) {
                  node.users.push(alteredRow?.user);
                  tree?.children?.push(node);
                }
              }
              break;

            case roles[2]:
              node = {
                data: alteredRow?.data,
                users: [],
                children: [],
              };
              if (tree?.children?.length > 0) {
                tree?.children?.forEach((stateRow, i) => {
                  if (
                    alteredRow?.data?.parent_unique_id ===
                    stateRow?.data?.unique_id
                  ) {
                    let dataExistsAlready = false;
                    stateRow?.children?.length > 0 &&
                      stateRow?.children?.forEach((child, j) => {
                        if (child?.data?.unique_id === node?.data?.unique_id) {
                          dataExistsAlready = true;
                          tree?.children[i]?.children[j]?.users?.push(
                            alteredRow?.user
                          );
                        }
                      });

                    if (!dataExistsAlready) {
                      node.users.push(alteredRow?.user);
                      tree?.children[i]?.children?.push(node);
                    }
                  }
                });
              }
              break;

            case roles[3]:
              node = {
                data: alteredRow?.data,
                users: [],
              };
              if (tree?.children?.length > 0) {
                tree?.children?.forEach((stateRow, i) => {
                  if (stateRow?.children?.length > 0) {
                    stateRow?.children?.forEach((districtRow, j) => {
                      if (
                        alteredRow?.data?.parent_unique_id ===
                        districtRow?.data?.unique_id
                      ) {
                        let dataExistsAlready = false;
                        districtRow?.children?.length > 0 &&
                          districtRow?.children?.forEach((child, k) => {
                            if (
                              child?.data?.unique_id === node?.data?.unique_id
                            ) {
                              dataExistsAlready = true;
                              tree?.children[i]?.children[j]?.children[
                                k
                              ]?.users?.push(alteredRow?.user);
                            }
                          });

                        if (!dataExistsAlready) {
                          node.users.push(alteredRow?.user);
                          tree?.children[i]?.children[j]?.children?.push(node);
                        }
                      }
                    });
                  }
                });
              }
              break;
          }
        }
      });
    });

    setNodesTree(tree);
  };

  const sortMappedData = (mappedData) => {
    let sortedData = [];
    const roles = ["ministry", "state", "district", "hospital"];

    roles.forEach((role) => {
      const filteredData = mappedData.filter((dataRow) => {
        return dataRow.user_role.includes(role);
      });

      sortedData = sortedData.concat(
        sortObjectsArrayByKey(filteredData, "unique_id")
      );
    });

    setCsvSortedMappedData(sortedData);
  };

  const sortObjectsArrayByKey = (arr, key) => {
    arr.sort((a, b) => {
      return a[key].split("-")[1] - b[key].split("-")[1];
    });
    return arr;
  };

  const processCSV = (str, delim = ",") => {
    const headers = str.slice(0, str.indexOf("\n")).split(delim);
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");

    let mappedDataArray = [];

    const newArray = rows.map((row) => {
      if (row) {
        const nestedStringsEndpoints = getAllIndexes(row, '"');
        const specificReplacementStr = "|-|-|-|-|";

        for (let i = 1; i <= nestedStringsEndpoints.length; i += 2) {
          const nestedString = row.slice(
            getNthIndexOfSubstringInString(row, '"', i) + 1,
            getNthIndexOfSubstringInString(row, '"', i + 1)
          );
          row = row.replace(
            nestedString,
            nestedString.replaceAll(",", specificReplacementStr)
          );
        }

        const values = row.split(delim);
        const eachObject = headers.reduce((obj, header, i) => {
          let value = values[i]?.replaceAll('"', "");
          value = value?.replaceAll(specificReplacementStr, ",");
          obj[header] = value;

          return obj;
        }, {});

        const mappedObject = headers.reduce((obj, header) => {
          const newKey = keyOfData(getFirstLettersOfStringWords(header));
          if (newKey === "user_role") {
            const role = findRole(eachObject[header]);
            obj[newKey] = role;
            obj["category"] = role;
          } else {
            obj[newKey] = eachObject[header] === "-" ? "" : eachObject[header];
          }
          return obj;
        }, {});

        mappedDataArray.push(mappedObject);
        return eachObject;
      } else {
        return null;
      }
    });

    setCsvMappedData(mappedDataArray);
    setCsvDataHeaders(headers);
    setCsvDataRows(newArray);
  };

  const getFirstLettersOfStringWords = (str) => {
    const firstLetters = str
      .split(" ")
      .map((word) => word[0] && word[0].toLowerCase())
      .join("");

    return firstLetters;
  };

  const keyOfData = (key) => {
    switch (key) {
      case "nonm":
        return "user_name";
      case "eonm":
        return "user_email";
      case "non":
        return "name";
      case "uin":
        return "unique_id";
      case "puin":
        return "parent_unique_id";
      case "con":
        return "user_role";
      case "ps":
        return "population";
      case "efv":
        return "eligible_count";
      case "pv":
        return "percentage_vaccinated";
      default:
        return "";
    }
  };

  const findRole = (value) => {
    value = value.toLowerCase();
    if (value.includes("ministry")) {
      return "ministry";
    } else if (value.includes("province")) {
      return "state";
    } else if (value.includes("district")) {
      return "district";
    } else if (value.includes("pou")) {
      return "hospital";
    }
  };

  // life cycle

  useEffect(() => {
    if (csvDataRows?.length > 0 && csvDataHeaders?.length > 0) {
      setCsvFileDataPreview(true);
    }
  }, [csvDataRows, csvDataHeaders]);

  useEffect(() => {
    if (csvFile) {
      handleCsvFile();
    }
  }, [csvFile]);

  useEffect(() => {
    if (csvMappedData?.length > 0) {
      sortMappedData(csvMappedData);
    }
  }, [csvMappedData]);

  useEffect(() => {
    if (csvSortedMappedData?.length > 0) {
      createNodesTree();
    }
  }, [csvSortedMappedData]);

  // styles
  const classes = useStyles();

  //render

  return (
    <>
      <Modal
        open={!!showCsvModal}
        onClose={handleFileUploadModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            minWidth: "50%",
            maxWidth: "90%",
            maxHeight: "90%",
            boxShadow: 24,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            style={{
              padding: "1rem",
              borderBottom: "1px solid grey",
            }}
          >
            <Typography variant="h5" component="h2">
              Upload File
            </Typography>
          </Box>
          <Box className={classes.hiddenScrollBar}>
            <Box>
              <Button variant="contained" component="label">
                Browse file
                <input
                  type={"file"}
                  accept={".csv"}
                  onChange={(e) => {
                    setCsvFile(e.target.files[0]);
                  }}
                  hidden
                />
              </Button>
            </Box>
            <Box style={{ marginTop: "1rem" }}>
              {csvFileDataPreview ? (
                <TableContainer component={Paper}>
                  <Table>
                    {csvDataHeaders.map((header, i) => (
                      <TableCell
                        align="center"
                        key={`${i}-table-heading-${header}`}
                      >
                        <Chip
                          label={header}
                          sx={{
                            backgroundColor: `${theme.palette.secondary.dark}`,
                            borderRadius: 2,
                            color: "blue",
                            fontWeight: "bold",
                          }}
                        ></Chip>
                      </TableCell>
                    ))}
                    <TableBody>
                      {csvDataRows.map((item, i) =>
                        item ? (
                          <TableRow key={i}>
                            {csvDataHeaders.map((header, j) => (
                              <TableCell
                                align="center"
                                key={`${i}-table-row-${j}-${item[header]}`}
                              >
                                {item[header]}
                              </TableCell>
                            ))}
                          </TableRow>
                        ) : null
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : null}
            </Box>
          </Box>
          <Box
            
            style={{
              padding: { xs: "1%", sm: "3%", md: "10%" },
              borderTop: "1px solid grey",
              textAlign: "end",
            }}
          >
            <Button
              mt={1}
              variant="contained"
              sx={{ marginRight: "0.5rem", backgroundColor: "gray" , marginTop:1 , marginBottom:1 }}
              onClick={() => {
                handleFileUploadModalClose();
              }}
            >
              Cancel
            </Button>
            <Button
              
              color="primary"
              variant="contained"
              disabled={!(Object.keys(nodesTree).length > 0)}
              onClick={() => {
                if (nodesTree) {
                  fileUpload();
                }
              }}
            >
              Upload
            </Button>
          </Box>
        </Box>
      </Modal>

      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={loaderOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleAlertClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UploadCSV;
